
<img *ngIf="imageUrl" [src]="imageUrl" alt="">
